import {Style, Icon} from 'ol/style';
import ky from 'ky';

const ICONS_CACHE = {};
export const icon_img = async (styleDef,layer,__style) => {

	const ratio = layer.ratio || 1;
	const iconSize = styleDef.size * ratio;

	const anchor = layer.anchor || [0.5,0.5]
	if(styleDef.anchor)
	{
		anchor[0] = anchor[0] + (styleDef.anchor[0] - 0.5)/ratio;
		anchor[1] = anchor[1] + (styleDef.anchor[1] - 0.5)/ratio;
	}

	var icon = ICONS_CACHE[layer.src] ? ICONS_CACHE[layer.src]+"" : false;
	if(!icon)
	{
		ICONS_CACHE[layer.src] = layer.src;
		icon = ICONS_CACHE[layer.src]+"";
	}

	const img_style = new Style({
		zIndex: styleDef.zIndex,
		image: new Icon({
			displacement:[0,0],
			anchor:anchor,
			color: layer.color || '#fff',
			imgSize:null,
			size:null,
			scale: layer.ratio,
			src: icon,
			opacity: layer.opacity || 1,
		})
	})

	const img = new Image();
	img.onload = () => {
		const realSize = Math.max(img.width,img.height)
		img_style.getImage().setScale(iconSize/realSize);
	}
	img.src = icon

	__style.push(img_style);
};

export  default icon_img;